var render = function render(){var _vm=this,_c=_vm._self._c;return (Number(_vm.balance) > 0)?_c('div',{staticClass:"text-center"},[_c('vs-chip',{staticClass:"w-full f-bold",staticStyle:{"font-size":"2em","border-radius":"5px"},attrs:{"color":"#28C76F"}},[_vm._v("\n        "+_vm._s(_vm.chipText)+"\n    ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }